import React, {FC} from 'react';

import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {Avatar, AvatarProps} from './avatar';
import {AvatarDashBorder} from './avatarDashBorder';
import {AvatarInitials} from './avatarInitials';

/*
 * Props.
 */

interface VisitorTeammateAvatarProps extends AvatarProps {
  initials: string;
  isSelected?: boolean;
}

/*
 * Component.
 */

export const VisitorTeammateAvatar: FC<VisitorTeammateAvatarProps> = (props) => {
  const theme = useUserTheme();
  const color = props.isSelected ? theme.greys.white : theme.greys.shade60;
  return (
    <Avatar {...props}>
      <AvatarDashBorder color={color} />
      <AvatarInitials size={props.size} textColor={color} value={props.initials} />
    </Avatar>
  );
};
